import { Navigate, Route, Routes } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth/types';
import { ValidationLayout } from 'src/features/validations/components/ValidationLayout';
import ValidationTable from 'src/features/validations/routes/ValidationTable';
import useHasPermissions from 'src/hooks/useHasPermissions';
import ValidationsTableAccountDashboard from 'src/features/validations/components/tables/ValidationsTableAccountDashboard';
import { PATH } from 'src/features/navigation/utils/constants';

export default function ValidationRoutes() {
    const accessValidations = useHasPermissions([PERMISSION.ALLOW_VALIDATIONS]);
    const accessSearchActiveStaysPermission = useHasPermissions([
        PERMISSION.ACCESS_ACTIVE_STAYS,
        PERMISSION.ALLOW_VALIDATIONS,
    ]);
    const accessValidationsPermission = useHasPermissions([PERMISSION.MANAGE_VALIDATIONS]);

    const defaultRoutePath = (() => {
        if (accessSearchActiveStaysPermission) return `/${PATH.VALIDATIONS}/search`;
        if (accessValidationsPermission) return `/${PATH.VALIDATIONS}/past-validations`;

        return '/';
    })();

    return (
        <Routes>
            {accessValidations && (
                <Route path="" element={<ValidationLayout />}>
                    <Route index element={<Navigate to={defaultRoutePath} replace />} />
                    <Route path="search" element={<ValidationTable />} />
                    <Route path="past-validations" element={<ValidationsTableAccountDashboard />} />
                </Route>
            )}
        </Routes>
    );
}
